// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Spin } from 'antd'
import { getPortfolioSnapshot } from '../../actions/portfolios'
import ComponentContainer from '../container-component'
import RiskProfileComponent from './risk-profile'
import { StyledContent } from './style'

class RiskProfile2 extends Component {
  
  state = {
    dataReady: false,
    selectedTrade: null,
  }
  
  componentDidMount() {
    this.props.getPortfoliosList()
  }
  
  async componentDidUpdate() {
    // validate that data is ready to be added to chart
    if (this.props.portfolios.portfolioSnapshot.length > 0 && !this.state.dataReady) {
      const {
        portfolios: {portfolioSnapshot},
      } = this.props;
      let allOpenTrades = portfolioSnapshot;
      const selectedTrade = allOpenTrades.find(x => x.tradeID === this.props.tradeId) || {}
      this.setState({ dataReady: true,  selectedTrade,});
    }
  }
  
  getPortfolioSnapshot = () => {
    this.props.getPortfoliosList()
  }
  render() {
    
    const {
      portfolios: {
        isFetching,
        error,
      },
    } = this.props
    
    const {selectedTrade } = this.state;
    return (
      <Row>
        <Col span={24}>
          <StyledContent>
            <section>
              { (isFetching || !!error || !selectedTrade ) ?
                (
                  <ComponentContainer
                    title={error || 'Loading Risk Profile'}
                    loading={isFetching}
                    empty={!!error}
                    resetData={this.getPortfolioSnapshot}>
                    
                    <p>Risk Profile</p>
                  </ComponentContainer>
                ) :
                (
                  <RiskProfileComponent selectedTrade={selectedTrade}/>
                )
              }
            </section>
          </StyledContent>
        </Col>
      </Row>
    )
  }
}

const mapStateToProps = (state: Object) => ({
  portfolios: state.portfolios,
})

const mapDispatchToProps = (dispatch: Function) => ({
  getPortfoliosList() {
    getPortfolioSnapshot(dispatch)
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(RiskProfile2)



// WEBPACK FOOTER //
// ./src/components/view-trades/RiskProfile2.js